var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#707070;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-9{fill-rule:evenodd;}.cls-4{fill:#999;}.cls-5{fill:#ce8b74;}.cls-6{fill:#b26550;}.cls-7,.cls-8{fill:#222c30;}.cls-9{fill:#4d4d4d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1,
    width: 145,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.6,121.42S37.24,192.1,25.77,170.71c-2.24-4.17-4.39-95-4.39-99.51C21.38,43.46,44.6,21,71.6,21V121.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.48,21c27.73,0,50.74,22.48,50.74,50.22,0,8.09-1.22,97.82-4.62,104.59-8.25,16.44-28-26.5-45.6-54.37L68.41,71.2l3-50.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.87,78.37A7.18,7.18,0,1,0,115,85.55a7.17,7.17,0,0,0-7.17-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.87,82a3.59,3.59,0,1,0,3.59,3.59A3.59,3.59,0,0,0,107.87,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.71,78.37a7.18,7.18,0,1,0,7.18,7.18,7.17,7.17,0,0,0-7.18-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.71,82a3.59,3.59,0,1,0,3.59,3.59A3.58,3.58,0,0,0,36.71,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.59,48.5a35.56,35.56,0,0,1,8,22.7v35.87a35.5,35.5,0,1,1-71,0V71.2a35.48,35.48,0,0,1,7.91-22.7,49.59,49.59,0,0,0,55.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46,81.42a1.88,1.88,0,0,1,.55-3.71l14.85,2.2a1.88,1.88,0,0,1-.55,3.71L46,81.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.09,83.52a1.88,1.88,0,0,1,0-3.75l15,0a1.88,1.88,0,1,1,0,3.75l-15,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 54.59,
    cy: 88.85,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 91.48,
    cy: 88.85,
    r: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.66,99.77l-.24-8.7a2.17,2.17,0,1,0-4.34.12h0l.18,6.52-2.18.06a6.53,6.53,0,0,0,.36,13l4.35-.13a2.17,2.17,0,0,0,2.11-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102,91.91H80.62A4.34,4.34,0,0,0,77,94a7,7,0,0,0-4.94-2H71.6a8.44,8.44,0,0,0-4.71,2,3.94,3.94,0,0,0-3.38-2H42.13a1.5,1.5,0,0,0,0,3H46.6v4.22a6.69,6.69,0,0,0,6.94,6.78h7.12a6.8,6.8,0,0,0,6.9-7,4.16,4.16,0,0,1,4-4.1l.47-.09A4.21,4.21,0,0,1,76.35,99a7,7,0,0,0,7.12,7H90.6a6.75,6.75,0,0,0,7-6.78V94.91H102a1.5,1.5,0,0,0,0-3ZM64.6,99.13c0,2.35-1.59,4.78-3.94,4.78H53.54c-2.35,0-3.94-2.43-3.94-4.78V94.91H63.51c.79,0,1.09.58,1.09,1.37Zm30,0c0,2.35-1.65,4.78-4,4.78H83.47c-2.34,0-3.87-2.43-3.87-4.78V96.28c0-.79.23-1.37,1-1.37h14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 89.85,
    cy: 111.04,
    r: 1.17
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual2);
export default __webpack_public_path__ + "static/media/character-head-individual-2.68bbc6f42a55d87c2034c7cf6920bc85.svg";
export { ForwardRef as ReactComponent };